import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet } from '../api';
import { IStorageBillingInvoices, IStorageBillingInvoicesGroupedByMonth } from 'types/billing.types';
import { ISellerBillingEntity } from 'types/billing.types';
import { IInvoiceStorageRecord } from 'components/InvoiceSectionOfBillingTab/InvoiceSectionOfBillingTab.types';
import { apiPut } from '../api';

const { REACT_APP_SUBSCRIPTION } = process.env;

export const getStorageBillingInvoices = async (key: string): Promise<IStorageBillingInvoicesGroupedByMonth> => {
  return apiGet<AxiosRequestConfig, IStorageBillingInvoicesGroupedByMonth>(`${REACT_APP_SUBSCRIPTION}${key}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getStorageBillingInvoiceById = async (storageInvoiceId: number): Promise<IStorageBillingInvoices> => {
  return apiGet<AxiosRequestConfig, IStorageBillingInvoices>(
    `${REACT_APP_SUBSCRIPTION}/storage-invoice/get-invoice/${storageInvoiceId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getAllBillingEntitiesBord = async () => {
  return apiGet<AxiosRequestConfig, ISellerBillingEntity[]>(
    `${REACT_APP_SUBSCRIPTION}/billing-method/all-seller-billing-entities`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getInvoiceStorageRecord = async (storageInvoiceId: number) => {
  return apiGet<AxiosRequestConfig, IInvoiceStorageRecord[]>(
    `${REACT_APP_SUBSCRIPTION}/storage-invoice/get-only-invoice-record/${storageInvoiceId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const updateStorageInvoiceRecord = async (
  storageInvoiceId: number,
  invoiceRecord: IInvoiceStorageRecord
): Promise<IInvoiceStorageRecord> => {
  return apiPut<AxiosRequestConfig, IInvoiceStorageRecord>(
    `${REACT_APP_SUBSCRIPTION}/storage-invoice/update-invoice-record/${storageInvoiceId}`,
    invoiceRecord
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const generateExportDetailUrl = async (storageInvoiceId?: number): Promise<{ templateUrl: string }> => {
  return apiGet<AxiosRequestConfig, { templateUrl: string }>(
    `${REACT_APP_SUBSCRIPTION}/storage-invoice/generate-template/${storageInvoiceId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const generateCreditInvoiceUrl = async (storageInvoiceId: number): Promise<{ invoiceUrl: string }> => {
  return apiGet<AxiosRequestConfig, { invoiceUrl: string }>(
    `${REACT_APP_SUBSCRIPTION}/storage-invoice/generate-credit-invoice/${storageInvoiceId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
